//TODO Rename x-shift to x-mode when in proxy-adapter it will be renamed
export const modeHeaderKey = 'x-shift';
